/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdWebFeaturesFriendsGetFriendsRequestToJSON, FxIdWebFeaturesFriendsGetFriendsResponseFromJSON, FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestToJSON, FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSON, FxIdWebFeaturesFriendsSetStatusRequestToJSON, } from '../models/index';
/**
 *
 */
export class FriendsApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesFriendsGetFriendsEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesFriendsGetFriendsRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesFriendsGetFriendsRequest', 'Required parameter "fxIdWebFeaturesFriendsGetFriendsRequest" was null or undefined when calling fxIdWebFeaturesFriendsGetFriendsEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/friends/get`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesFriendsGetFriendsRequestToJSON(requestParameters['fxIdWebFeaturesFriendsGetFriendsRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesFriendsGetFriendsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesFriendsGetFriendsEndpoint(fxIdWebFeaturesFriendsGetFriendsRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesFriendsGetFriendsEndpointRaw({ fxIdWebFeaturesFriendsGetFriendsRequest: fxIdWebFeaturesFriendsGetFriendsRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesFriendsSendFriendInviteNotificationEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest', 'Required parameter "fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest" was null or undefined when calling fxIdWebFeaturesFriendsSendFriendInviteNotificationEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/friends/send_invite_notification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestToJSON(requestParameters['fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesFriendsSendFriendInviteNotificationEndpoint(fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesFriendsSendFriendInviteNotificationEndpointRaw({ fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest: fxIdWebFeaturesFriendsSendFriendInviteNotificationRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesFriendsSetStatusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesFriendsSetStatusRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesFriendsSetStatusRequest', 'Required parameter "fxIdWebFeaturesFriendsSetStatusRequest" was null or undefined when calling fxIdWebFeaturesFriendsSetStatusEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/friends/status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesFriendsSetStatusRequestToJSON(requestParameters['fxIdWebFeaturesFriendsSetStatusRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fxIdWebFeaturesFriendsSetStatusEndpoint(fxIdWebFeaturesFriendsSetStatusRequest, initOverrides) {
        await this.fxIdWebFeaturesFriendsSetStatusEndpointRaw({ fxIdWebFeaturesFriendsSetStatusRequest: fxIdWebFeaturesFriendsSetStatusRequest }, initOverrides);
    }
}
//# sourceMappingURL=FriendsApi.js.map